import { Box, VStack } from '@bpba/ui-components';
import { Footer } from '../footer/Footer';
import { Header } from '../header/Header';
import { ErrorComponent } from './ErrorComponent';

/**
 * Página default en caso de falla en el render de algún componente.
 */
export function BackupDefaultPage() {
  return (
    <>
      <Header />
      <Box width="100%" maxWidth="unset" px="0px" marginTop={[125, 136, 139]}>
        <VStack width="100%" alignItems="center">
          <ErrorComponent />
        </VStack>
      </Box>
      <Footer />
    </>
  );
}
